import { useLocation, useNavigate } from "react-router-dom";



export default function usePaginationSearchURL() {
  const location : string = useLocation().search;
  let  pageParams  = new URLSearchParams(location).get('page');
  const navigate = useNavigate()

  const goToPage = (page: number) => {
        
    const params = new URLSearchParams(location);
    params.set('page', page.toString())
    const path = location.split('?')[0] + '?' + params.toString()
    navigate(path)
}

const setQuerySearch = (querySearch: string | null) => {
    const params = new URLSearchParams(location);
    params.set('querySearch', querySearch || "")
    const path = location.split('?')[0] + '?' + params.toString()
    navigate(path)
}

const getQuerySearch = () => {
    const params = new URLSearchParams(location);
    const querySearch = params.get('querySearch') || ""
    return querySearch
}
const getCurrentPage = () => pageParams ? parseInt(pageParams) : null

  return{
    getCurrentPage,
    goToPage,
    setQuerySearch,
    getQuerySearch,
  }
}
